module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0122.jpg?v=dc209d9a";